import {
  EditManagerInputControllerProps,
  handleOnEditManagerGoodScoreFieldChange,
} from "@pages/suppliers/_id/_products/investment-product/_id/edit/components/tabs/manager/util";
import { Controller, useFormContext } from "react-hook-form";
import { InvestmentProductManagerDTO } from "@models/product/investment-product/entities/manager";
import { useEditManagerPaths } from "@hooks/useInvestmentProduct";
import { debounce, isNil } from "lodash";
import { SHBooleanField } from "@components/design-systems";
import { useMount } from "react-use";
import { EditProductDefaults } from "@pages/suppliers/_id/_products/investment-product/_id/edit/constants";

export const EditManagerGoodScoreInput = ({
  featureData,
  featureIndex,
  sectionIndex,
  isDisabled,
  onChange,
}: EditManagerInputControllerProps) => {
  const { control, setValue } = useFormContext<InvestmentProductManagerDTO>();

  const { featureProductDataPath } = useEditManagerPaths(
    sectionIndex,
    featureIndex,
  );

  const handleOnChange = (newValue: boolean) => {
    handleOnEditManagerGoodScoreFieldChange({
      originalValue: featureData.productData?.isPositiveScore,
      newValue,
      setValue,
      featureProductDataPath,
    });
    onChange && onChange({ sectionIndex, featureIndex });
  };

  const debouncedHandleInputChange = debounce(
    handleOnChange,
    EditProductDefaults.DebounceTime,
  );

  useMount(() => {
    const positiveScoreData = featureData.productData?.isPositiveScore;

    if (!isNil(positiveScoreData)) return;

    setValue(
      featureProductDataPath.isPositiveScore,
      Boolean(positiveScoreData),
    );
  });

  return (
    <Controller
      name={featureProductDataPath.isPositiveScore}
      control={control}
      render={({ field: { ref, ...other } }) => (
        <SHBooleanField
          {...other}
          disabled={isDisabled}
          value={Boolean(other.value)}
          isSwitch
          startAdornment="Good score?"
          isShowClearButton={false}
          onChange={(event) => {
            const newValue = !!event.target.value;
            other.onChange(newValue);
            debouncedHandleInputChange(newValue);
          }}
        />
      )}
    />
  );
};
